import { NgModule } from '@angular/core';
import { StickyFooterComponent } from './sticky-footer.component';
import { StickyFooterSecondaryDirective } from './directives/sticky-footer-secondary.directive';
import { CommonModule } from '@angular/common';
export { StickyFooterSecondaryDirective } from './directives/sticky-footer-secondary.directive';
export { StickyFooterComponent } from './sticky-footer.component';

export const MODULE_EXPORTS = [StickyFooterComponent, StickyFooterSecondaryDirective];

export const MODULE_DECLARATIONS = [StickyFooterComponent, StickyFooterSecondaryDirective];

export const MODULE_IMPORTS = [CommonModule];
@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
  exports: MODULE_EXPORTS,
})
export class GalaxyStickyFooterModule {}
